// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3MYTR","toggle":"styles_toggle__3NWMH","preview":"styles_preview__3VrnX"};